import React from 'react';
import ModalWrapper, { withOnClose } from './ModalWrapper';
import Translator from '../../requests/apa/Translator';
import Asset from '../../requests/apa/Asset';
import PropTypes from 'prop-types';

const AAFModalSuccessPTV = (props = {}) => {
  const title = Translator.get('iptv_modal_title_label','Activación exitosa');
  const p = {
    title,
    alwaysEnabled: true,
    buttons: [
      {
        content: Translator.get('iptv_modal_option_button_close', 'ACEPTAR'),
        props: {
          onClick: (e) => {props.handleClose(e, props.callback);},
          className: 'aaf-modal-button aaf-modal-button-primary'
        }
      }
    ],
    aafNewStyle: true,
    className: 'aaf-modal',
    asset: Asset.get('mail_modal_icon_confirm'),
    callbackWhenBack:  props.callback
  };
  return <ModalWrapper {...p} />;
};

AAFModalSuccessPTV.propTypes = {
  title: PropTypes.string,
  className: PropTypes.string
};

export default withOnClose(AAFModalSuccessPTV);



// WEBPACK FOOTER //
// ./src/components/Modal/AAFModalSuccessPTVShort.jsx